import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  spacing: 4,
  palette: {
    mode: "dark",
    primary: {
      main: "#6F8BFF"
    },
    secondary: {
      main: "#A3AAC4"
    },
    background: {
      paper: "#2E3A43",
      default: "#1D262C"
    },
    text: {
      primary: "#F4FFFD",
      secondary: "#C2EFEA"
    }
  },
  typography: {
    fontFamily: `"Montserrat", "Helvetica", "Arial", sans-serif`,
    h1: { fontSize: "2.2rem", fontWeight: 700, letterSpacing: "0.5px" },
    h2: { fontSize: "1.8rem", fontWeight: 600, letterSpacing: "0.4px" },
    h3: { fontSize: "1.6rem", fontWeight: 600, letterSpacing: "0.3px" },
    body1: { fontSize: "1rem", fontWeight: 400, lineHeight: 1.6 },
    body2: { fontSize: "0.95rem", fontWeight: 400, lineHeight: 1.5 },
    button: {
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "1px"
    }
  },
  shape: {
    borderRadius: 12
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: "none",
          fontWeight: 600,
          letterSpacing: "0.04em"
        },
        contained: {
          backgroundColor: "transparent",
          boxShadow: "none",
          border: `1.5px solid #6F8BFF`,
          color: "#6F8BFF",
          "&:hover": {
            backgroundColor: "rgba(111, 139, 255, 0.18)",
            boxShadow: "none"
          }
        },
        outlined: {
          borderWidth: 1.5
        }
      }
    }
  }
});

export default theme;
